export default {"src":"/_next/static/media/0x305e88d809c9dc03179554bfbf85ac05ce8f18d6.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};